module.exports = "https://cdn.realtymogul.com/static/media/tooltip_icon.52fe7f26.svg";